import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";
import { database } from "../../firebase";
import { ReactComponent as Globe } from "../../assets/images/globe.svg";
import facebook from "../../assets/images/social_facebook.jpg";
import instagram from "../../assets/images/social_instagram.jpg";
import twitter from "../../assets/images/social_twitter.jpg";
import youtube from "../../assets/images/youtube.png";
import spotify from "../../assets/images/spotify.png";
import soundcloud from "../../assets/images/soundcloud.png";
import applemusic from "../../assets/images/music_applemusic.jpg";
import MusicList from "../../components/MusicList";
import VideoList from "../../components/VideoList";
import { withRouter } from "react-router-dom";
import PropType from "prop-types";
import styles from "./style.module.scss";
import profileActions from "../../redux/profile/actions";
import userImage from "../../assets/images/user";
import { useOutsideAlerter } from "../../hooks/utils";
import LazyLoad from "react-lazyload";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import './profile.css'
import ConnectRequest from "../../components/ConnectRequest";
const Profile2 = ({ history }) => {
  const wrapperRef = useRef(null);
  const [status, setStatus] = useState("Independent");
  const [showForm, setShowForm] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const [link, setLink] = useState("");
  const [achivements, setAchivements] = useState([])

  const {
    currentUser,
    creditzIds,
    Loading = [],
  } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
    creditzIds: state.profile.creditzIds,
    Loading: state.profile.Loading,
  }));
  const [facebooklink, setFacebookLink] = useState(currentUser.facebooklink);
  const [instagramlink, setInstagramLink] = useState(currentUser.instagramlink);
  const [twitterlink, setTwitterLink] = useState(currentUser.twitterlink);
  const [trillerlink, setTrillerlink] = useState(currentUser.trillerlink)
  const [youtubelink, setYoutubelink] = useState(currentUser.youtubelink)
  const [soundcloudlink, setSoundCloudlink] = useState(currentUser.soundcloudlink)
  const [linkvalue, setLinkvalue] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useOutsideAlerter(wrapperRef, setShowForm);

  const changeStatus = (st) => {
    setShowForm(false);
    if (st === "Independent") {
      setNewStatus("");
    }
    setStatus(st);
  };

  const onBlurNewStatus = () => {
    dispatch({
      type: profileActions.UPDATE_USER_STATUS,
      payload: {
        currentUser: {
          ...currentUser,
          status: newStatus ? `${status} ${newStatus}` : status,
        },
      },
    });
  };

  const dispatch = useDispatch();
  const [requests, setRequests] = useState([]);
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function getConnections(uid) {
    return database
      .ref(`/connectuser/${uid}`)
      .orderByChild("status")
      .equalTo("Accepted")
      .once("value")
      .then(async (snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
          array.push(childSnapshot.key);
        });
        var results = await Promise.all(
          array.map(async (item) => {
            const data = await getUserData(item);
            return data;
          })
        );
        setRequests([...results]);
        return array;
      });
  }
  useEffect(() => {

    getConnections(currentUser.uid);
  }, []);

  useEffect(() => {
    dispatch({
      type: profileActions.GET_USER_MUSICS,
    });
  }, []);
  useEffect(() => {
    if (currentUser.facebooklink) {
      setFacebookLink(currentUser.facebooklink);
    } else {
      setFacebookLink("");
    }

    if (currentUser.instagramlink) {
      setInstagramLink(currentUser.instagramlink);
    } else {
      setInstagramLink("");
    }

    if (currentUser.twitterlink) {
      setTwitterLink(currentUser.twitterlink);
    } else {
      setTwitterLink("");
    }
    if (currentUser.youtubelink) {
      setYoutubelink(currentUser.youtubelink)
    }
    else {
      setYoutubelink("")
    }
    if (currentUser.trillerlink) {
      setTrillerlink(currentUser.trillerlink)
    } else {
      setTrillerlink("")
    }
    if (currentUser.soundcloudlink) {
      setSoundCloudlink(currentUser.soundcloudlink)
    }
    else {
      setSoundCloudlink("")
    }
  }, [currentUser]);
  function updateStatus() {
    let userRef = database.ref("users/" + currentUser.uid);
    userRef.update({ ActiveStatus: "online" });
  }
  useEffect(() => {
    setNewStatus("");
    setStatus(currentUser.status || "Independent");
    updateStatus();
  }, [currentUser.status]);
  document.title = "My Profile";

  const [accepted, setAccepted] = useState([]);
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function getCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function AcceptedCreditz() {
    return database
      .ref(`/user-creditz/`)
      .once("value")
      .then(async (snapshot) => {
        const creditRequests = [];
        const request = [];
        let us = [];
        snapshot.forEach((childSnapshot) => {
          request.push(Object.values(childSnapshot.val()));
          us = request
            .map((req) => {
              return req.find((r) => {
                return r.email === currentUser.email;
              });
            })
            .filter((e) => e);
        });

        const pendingRequests = [];

        us.map((req) => {
          if (req.status === "Accepted ") {
            pendingRequests.push(req);
          }
        }).filter((e) => e);

        var newRes = await Promise.all(
          pendingRequests.map(async (user) => {
            const Data = await getUserData(user.uid);
            const Creddata = await getCreditzData(user.credid);
            const returnObj = {
              credid: user.credid,
              user_details: Data,
              Creditz: Creddata,
            };

            return returnObj;
          })
        );
        setAccepted(newRes);
      });
  }
  const [sent, setSent] = useState([]);
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function getCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function GetCreditz() {
    return database
      .ref("/creditz")
      .orderByChild("uid")
      .equalTo(currentUser.uid)
      .once("value")
      .then(async (snapshot) => {
        const creditz = [];
        snapshot.forEach((childSnapshot) => {
          creditz.push(childSnapshot.val());
        });
        setSent(creditz);
      });
  }

  useEffect(() => {
    AcceptedCreditz();
    GetCreditz();
  }, []);

  const getAchivements = () => {
    let achivements = [];
    return database.ref('achievements/' + currentUser.uid).orderByChild("isDeleted").equalTo(false).once("value")
      .then(async (snapshot) => {
        snapshot.forEach((childsnapshot) => {
          achivements.push(childsnapshot.val()
          )
        })
        setAchivements(achivements)
      }
      )
  }

  useEffect(() => {
    getAchivements()
  }, [currentUser])
  console.log(currentUser)
  return (
    <>
      {/* Left Aside */}
      <AsideNewFeed></AsideNewFeed>
      <section className="main-content">

        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-3">
              <div className="card border-0 rounded-xl shadow-xs overflow-hidden">
                <div className="card-body p-sm-4">
                  <div className="ratio profile-ratio overflow-hidden rounded-xl">
                    <img
                      src={(currentUser && currentUser.coverImageUrl) || userImage()}
                      alt="profile-cover"
                      className="w-100 bg-image-cover"
                    />
                  </div>
                </div>
                <div className="card-body position-relative d-flex flex-wrap align-items-end px-4 mmt-sm45-70">
                  <div>
                    <figure
                      className="mmwh-sm64-100 ratio ratio-1x1 rounded-circle overflow-hidden mb-3 mx-1 mx-sm-3"
                      style={{ border: "4px solid #fff" }}
                    >
                      <img
                        src={currentUser?.profileImageUrl || userImage()}
                        alt="user-avater"
                        className="w-100 h-100"
                      />

                    </figure>
                  </div>
                  <div className="mb-3 me-3">
                    <div className="capitalize">
                      <h5 className="fw-bold mb-0 mb-sm-1 capitalize">
                        {currentUser?.username}
                      </h5>
                    </div>
                    <small className="text-muted fw-semibold">
                      @{currentUser?.username}
                    </small>
                  </div>
                  <div style={{ 'margin-left': 'auto', alignSelf: 'center', paddingRight: '25px' }}>
                    <Link to='/edit-profile'>
                      <button
                        className="btn btn-secondary rounded-pill fw-semibold px-3">
                        Edit Profile
                      </button>
                    </Link>


                  </div>
                </div>

                <ul
                  className="nav nav-tabs profile-tab border-top border-bottom-0 ps-4"
                  role="tablist"
                >
                  <li className="list-inline-item me-4 me-sm-5">
                    <Link
                      to="#musicbox"
                      data-bs-toggle="tab"
                      className="active"
                    >
                      Music
                    </Link>
                  </li>
                  <li className="list-inline-item me-4 me-sm-5">
                    <Link to="#videobox" data-bs-toggle="tab">
                      Videos
                    </Link>
                  </li>
                  <li className="list-inline-item me-4 me-sm-5">
                    <Link to="#achievementsbox" data-bs-toggle="tab">
                      Achievements
                    </Link>
                  </li>
                  <li className="list-inline-item pe-4">
                    <Link to="#linksbox" data-bs-toggle="tab">
                      Links
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 pe-lg-0 mb-4">
              <div className="card border-0 rounded-xl shadow-xs">
                <div className="card-body p-4 border-bottom">
                  <h6 className="fw-semibold fs-12">About</h6>
                  <p className="fs-12 lh-lg mb-0 ">
                    {currentUser.bio}
                  </p>
                </div>

                <div className="card-body p-4">
                  <div className="ms-2">

                    <Row>
                      <Col md='12' sm='12'>
                        <div className="fs-12 text-muted fw-semibold">
                          Roles
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col>

                        <div style={{
                          'margin-top': '5px'
                        }}>

                          { currentUser.role ? currentUser?.role?.map((item) => (
                            <div className="badge px-3 py-2 rounded-pill fw-medium bg-purple me-1 mb-1" key={item}> {item}</div>
                          ))  
                        : <div className="badge px-3 py-2 rounded-pill fw-medium bg-purple me-1 mb-1" > {currentUser.accountType}</div>
                        }
                        </div>

                      </Col>

                    </Row>


                    <Row>
                      <Col md='12' sm='12'>
                        <div style={{ 'margin-top': '12px' }} className="fs-12 text-muted fw-semibold">
                          Genres
                        </div>
                      </Col>

                    </Row>
                    <Row><Col md='12' sm='12'>
                      <div style={{
                        'margin-top': '5px'
                      }}>

                        {currentUser.genres?.map((item) => (
                          <div className="badge px-3 py-2 rounded-pill fw-medium bg-primary me-1 mb-1" key={item}> {item}</div>
                        ))}
                      </div>
                    </Col></Row>


                    <Row><Col md='12' sm='12'>
                      <div style={{ 'margin-top': '12px' }} className="fs-12 text-muted fw-semibold">
                        Creditz
                      </div>
                    </Col></Row>
                    <Row> <Col md='12' sm='12'>
                      <h5 style={{ 'margin-top': '5px' }} className="fs-12 fw-medium  fw-bold mb-0">{accepted.length + sent.length}</h5>
                    </Col></Row>
                    <Row><Col md='12' sm='12'>
                      <div style={{ 'margin-top': '12px' }} className="fs-12 text-muted fw-semibold">
                        Status
                      </div>
                    </Col></Row>
                    <div
                      className="fs-12 fw-medium  fw-bold mb-0"
                      style={{ 'margin-top': '5px' }}
                      onClick={() => setShowForm(true)}
                    >
                      {status}
                    </div>
                    {showForm && (
                      <div className="fs-13 fw-bold mb-0">
                        <div
                          onClick={() => changeStatus("Independent")}
                          className="fw-medium text-muted"
                        >
                          🎤 Independent
                        </div>
                        <div
                          onClick={() => changeStatus("Working At")}
                          className="fw-medium text-muted"
                        >
                          {" "}
                          💼 Working At
                        </div>
                        <div
                          className="fw-medium text-muted"
                          onClick={() => changeStatus("Signed to")}
                        >
                          {" "}
                          ✍️ Signed to
                        </div>
                      </div>
                    )}
                    {(status === "Working At" ||
                      status === "Signed to") && (
                        <input
                          onChange={(e) => setNewStatus(e.target.value)}
                          onBlur={onBlurNewStatus}
                        />
                      )}
                    <Row><Col md='12' sm='12'>
                      <div style={{ 'margin-top': '12px' }} className="fs-12 text-muted fw-semibold">
                        Management
                      </div>
                    </Col></Row>
                  </div>


                </div>
              </div>
            </div>
            {/* // */}
            <div className="col-xl-8 col-lg-8 mb-4">
              <div className="tab-content">
                <div className="tab-pane fade show active" id="musicbox">
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-2 g-3">
                    <MusicList></MusicList>
                  </div>
                </div>
                <div className="tab-pane fade" id="videobox">
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-2 g-3">
                    <VideoList></VideoList>
                  </div>
                </div>
                <div className="tab-pane fade" id="achievementsbox">
                  {achivements?.map((achivement) => (

                    <div className="shadow p-3 mb-5 bg-white rounded">
                      <div className="card-body p-3 p-sm-4">
                        <div className="d-flex mb-3">


                          <div className="ps-3">
                            <h5>{achivement.type}</h5>
                            <h6>{achivement.title}</h6>
                            <p className="mb-1">{achivement.month} {achivement.year}</p>
                            <p>
                              {achivement.description}
                            </p>


                          </div>
                        </div>
                        <button id='seelink' type="button" onClick={() => window.open(achivement.sourceUrl)} class="btn btn-link">See link to achievement</button>



                      </div>
                    </div>
                  ))}


                </div>
                <div className="tab-pane fade" id="linksbox">
                  <div class="container">
                    <div class="row">
                      <div class="col">
                        <div className="card border-0 shadow-xs ">
                          <div className="card-body p-4">
                            <h5>Social</h5>
                            {facebooklink === "" ? "" :

                              <div className="card border-0 rounded-xl shadow-xs ">
                                <div className="card-header ">
                                  <div className="row">
                                    <div className="col-sm-2">
                                      <img src={facebook} />
                                    </div>
                                    <div
                                      className="col-sm-4"
                                      style={{ paddingTop: "15px" }}
                                    >
                                      <p>Facebook</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        paddingTop: "8px",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => {
                                          window.open(facebooklink);
                                        }}
                                        className="btn btn-primary fw-medium rounded-pill px-3"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }

                            <br></br>
                            {instagramlink === "" ? "" :

                              <div className="card border-0 rounded-xl shadow-xs ">
                                <div className="card-header ">
                                  <div className="row">
                                    <div className="col-sm-2">
                                      <img src={instagram} />
                                    </div>
                                    <div
                                      className="col-sm-4"
                                      style={{ paddingTop: "15px" }}
                                    >
                                      <p>Instragram</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        paddingTop: "8px",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => {
                                          window.open(instagramlink);
                                        }}
                                        className="btn btn-primary fw-medium rounded-pill px-3"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }

                            <br></br>
                            {twitterlink === "" ? "" :

                              <div className="card border-0 rounded-xl shadow-xs ">
                                <div className="card-header ">
                                  <div className="row">
                                    <div className="col-sm-2">
                                      <img src={twitter} />
                                    </div>
                                    <div
                                      className="col-sm-4"
                                      style={{ paddingTop: "15px" }}
                                    >
                                      <p>Twitter</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        paddingTop: "8px",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => {
                                          window.open(twitterlink);
                                        }}
                                        className="btn btn-primary fw-medium rounded-pill px-3"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }

                            {trillerlink === "" ? "" :

                              <div className="card border-0 rounded-xl shadow-xs ">
                                <div className="card-header ">
                                  <div className="row">
                                    <div className="col-sm-2">
                                      <img src="./assets/images/social_triller.jpg" className="mmwh-45 border rounded-lg" alt="social" />
                                    </div>
                                    <div
                                      className="col-sm-4"
                                      style={{ paddingTop: "15px" }}
                                    >
                                      <p>Triller</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        paddingTop: "8px",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => {
                                          window.open(trillerlink);
                                        }}
                                        className="btn btn-primary fw-medium rounded-pill px-3"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <br></br>
                        <div className="card border-0 shadow-xs rounded-xl">
                          <div className="card-body p-4">
                            <h5>Music</h5>
                            {youtubelink === "" ? "" :

                              <div className="card border-0 rounded-xl shadow-xs ">
                                <div className="card-header ">
                                  <div className="row">
                                    <div className="col-sm-2">
                                      <img src={youtube} />
                                    </div>
                                    <div
                                      className="col-sm-4"
                                      style={{ paddingTop: "15px" }}
                                    >
                                      <p>Youtube</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        paddingTop: "8px",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => {
                                          window.open(youtubelink);
                                        }}
                                        className="btn btn-primary fw-medium rounded-pill px-3"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            <br></br>
                            {soundcloudlink === "" ? "" :

                              <div className="card border-0 rounded-xl shadow-xs ">
                                <div className="card-header ">
                                  <div className="row">
                                    <div className="col-sm-2">
                                      <img src={soundcloud} />
                                    </div>
                                    <div
                                      className="col-sm-4"
                                      style={{ paddingTop: "15px" }}
                                    >
                                      <p>SoundCloud</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        paddingTop: "8px",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => {
                                          window.open(soundcloudlink);
                                        }}
                                        className="btn btn-primary fw-medium rounded-pill px-3"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-cols-1 g-3">
                    <div className="col-md"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Aside */}
      <div>
        <AsideContacts></AsideContacts>
      </div>

    </>
  );
};

Profile2.propTypes = {
  history: PropType.object,
};

export default withRouter(Profile2);
